import { Sorting } from 'interfaces/sorting';
import { create } from 'zustand';

type SortingState = {
  sorting: Sorting[];
  setSorting: (sorting: Sorting[]) => void;
};

export const useSortingStore = create<SortingState>((set) => ({
  sorting: [{ id: 'id', desc: true }],
  setSorting: (sorting) => set({ sorting }),
}));
